import React from 'react'
import { Wrapper } from 'SRC/ui/FormElements'
import { ImageManager } from 'Core/imageManager'
import PropTypes from 'prop-types'
import { Preloader } from 'SRC/ui/Preloader'

const getBase64 = (file) => {
  const reader = new FileReader()
  return new Promise(resolve => {
    reader.onload = ev => {
      resolve(ev.target.result)
    }
    reader.readAsDataURL(file)
  })
}

class Image extends React.Component {
  constructor (props) {
    super(props)

    const { image } = this.props

    this.imageManager = new ImageManager()
    this.maxWidth = 200
    this.maxHeight = 150

    this.state = {
      imgPreview: (image && typeof image === 'string') ? image : null
    }
  }

  componentDidUpdate = prevProps => {
    const { image } = this.props
    if ((!prevProps.image && image) || (prevProps.image && image && prevProps.image.name !== image.name)) {
      if (typeof image === 'string') return

      console.log('componentDidUpdate image', image)
      getBase64(image.file).then(
        file => {
          console.log('f', file)
          this.setState({ imgPreview: file })
        }
      )
    }
  }

  onChange = e => {
    const { setImage } = this.props

    const image = e.target.files[0]

    setImage({ file: image, name: image.name })
  }

  // removeImage = () => {
  //     this.props.setNewLogo(null)
  // }

  render () {
    const { image } = this.props
    const { imgPreview } = this.state

    console.log('imgPreview', imgPreview)

    return [
      <input
        id='logo'
        name='logo'
        type='file'
        accept={this.imageManager.allowedTypes.join(',')}
        style={{display: 'none'}}
        onChange={this.onChange}
        key='input'
      />,
      !image
        ? <Wrapper key='addLogoBtn'>
          <label className='dodaj-logo' htmlFor='logo' key='label' style={{textAlign: 'center', width: '14.7rem'}}>
            <i className='ico-tab-fotografije ico' />
            Dodaj sliku
          </label>
        </Wrapper>
        : (
          <div className='agent-image'>
            <div className='agent-image__preview' key='logo'>
              {imgPreview ? <img src={imgPreview} width={200} /> : null}
            </div>
            <div className='agent-image__actions' key='buttons'>
              <label htmlFor='logo'><i className='ico ico-poslate-poruke' />Izmijeni</label>
              <a
                onClick={this.removeImage}
                style={image && image.file ? null : {display: 'none'}}
              >
                <i className='ico ico-obrisati' />Obriši
              </a>
            </div>
          </div>
        )
    ]
  }
}

Image.propTypes = {
  image: PropTypes.shape({
    file: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isOriginal: PropTypes.bool
  }).isRequired,
  setImage: PropTypes.func.isRequired
}

export default Image
